module.exports = __webpack_public_path__ + "static/media/header_bg_4k.a365cd05.webp";